import { toastr } from "../_components/toastr/toastr";
import { accountService } from "../_services/accounts.service";

export function handleResponse(response: Response) {
    return response.text().then(text => {
        let data;

        //if (text.length && text.length > 1000)
        //    console.log("jsonsize", text.length);

        //if (text.length && text.length > 10000)
        //    console.error("ERROR jsonsize", text.length);

        try {
            data = text && JSON.parse(text);
        } catch (e) {
            data = text;
        }

        if (!response.ok) {
            if ([401, 403].indexOf(response.status) !== -1) {
                const message = typeof data === 'string'
                    ? data
                    : data?.message || data?.title || 'Your session ended because you signed in elsewhere.';
                accountService.logout(message);
            }

            return Promise.reject(data);
        }
        return data;
    });
}

export function handleErrorResponse(err: any) {
    toastr.error((err && err.response && err.response.data) ? err.response.data : err.Message || err.message || err.title || err || "Something went wrong. Please try again later");
}

export function handleErrorResponseAxios(err: any) {

    toastr.error((err && err.response ? err.response.data : null) || err.Message || err.message || err.title || err || "Something went wrong. Please try again later");
}